module.exports = __webpack_public_path__ + "img/product-ketang-jm-02.6fdcf10b.png";